import { WebAuthnAuthorizationState } from '#/src/shared/store/redux/webauthn/types';

export const WebAuthnAuthorizationInitialState: WebAuthnAuthorizationState = {
    error: '',
};
